module.exports = __webpack_public_path__ + "static/media/left-arrow-new.96b7e531.svg";